import classNames from 'classnames';
import { CSSProperties, useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { formatDate } from '~/services/sneaker-release/sneaker-release-transform';

function getRandomTwoDigitNumber() {
    return Math.floor(Math.random() * 90) + 10;
}

const ShiftingCountDown = ({ from = '', style = {} as CSSProperties, classNameRender = '' }) => {
    const [isComplete, setIsComplete] = useState(false);
    const [millisecondDisplay, setMillisecondDisplay] = useState(getRandomTwoDigitNumber());

    useEffect(() => {
        const interval = setInterval(() => {
            setMillisecondDisplay(getRandomTwoDigitNumber());
        }, 50);

        return () => clearInterval(interval);
    }, [from]);

    if (!from) return null;
    return (
        <div
            style={{
                letterSpacing: '0.1em',
                ...style
            }}
            className="text-black w-full"
        >
            {isComplete ? (
                <div style={style}>{formatDate(from)}</div>
            ) : (
                <Countdown
                    date={from}
                    onComplete={() => setIsComplete(true)}
                    renderer={({ days, hours, minutes, seconds }) => {
                        const d = days < 10 ? `0${days}` : days;
                        const h = hours < 10 ? `0${hours}` : hours;
                        const m = minutes < 10 ? `0${minutes}` : minutes;
                        const s = seconds < 10 ? `0${seconds}` : seconds;
                        const display = `H-${d}:${h}:${m}:${s}`;

                        return (
                            <div className={classNames('flex', classNameRender)}>
                                {display}
                                <div style={{ width: 25 }}>:{millisecondDisplay}</div>
                            </div>
                        );
                    }}
                    zeroPadTime={2}
                />
            )}
        </div>
    );
};

export default ShiftingCountDown;
